/**
 * Progressive hero video: show first frame as poster, play when buffered.
 */
export function initHeroVideos() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const saveData = connection?.saveData === true;

  document.querySelectorAll('[data-hero-video]').forEach((wrapper) => {
    const video = wrapper.querySelector('video[data-hero-video-file]');
    if (!video) {
      return;
    }

    // Keep the poster visible when motion is unwanted or data saving is enabled.
    if (prefersReducedMotion || saveData) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    video.preload = 'auto';
    video.defaultMuted = true;
    video.muted = true;

    const play = () => {
      video.play().catch(() => {
        // Autoplay can still be blocked (for example by iOS Low Power Mode).
        // In that case the poster/background supplied by the template remains.
      });
    };

    // Mobile browsers may fire canplay before deferred JavaScript executes,
    // or may not honour a later preload change. Handle both states.
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      play();
    } else {
      video.addEventListener('loadeddata', play, { once: true });
      video.addEventListener('canplay', play, { once: true });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroVideos);
} else {
  initHeroVideos();
}
